export class ApiPath {
  public static BASE_URL = process.env.VUE_APP_BASE_URL;
  public static LOGIN_URI = '/users/sign_in';
  public static LOGOUT_URI = '/users/sign_out';
  public static USERS = '/users';
  public static USER_EMAIL = '/users/email';
  public static USERS_CONFIRMATION = '/confirmations';
  public static CURRENT_USER = '/users/current';
  public static PROBE_URI = '/users/probe';
  public static STUDIO_INFO = '/studio/info';
  public static RESERVATIONS = '/studio/reservations';
  public static RESERVATIONS_COUNT = '/studio/reservations/count';
  public static RESERVE = '/studio/reserve';
  public static RESERVE_OPTIONS = '/studio/create_reservation_options';
  public static GET_RESERVATION_OPTIONS = '/studio/reservation_options';
  public static USAGE = '/studio/usage';
  public static PASSWORD_RESET_DEVISE = '/auth/password';
  public static PASSWORD_RESET = '/users/password';
  public static ROOM_IMAGE = '/studio/images';
  public static STORES = '/stores';
  public static USERS_PAYJP = '/users/payjp'
  public static USERS_CREDIT_CARDS = '/users/payjp/credit_cards'
  public static USERS_PAYJP_ID = '/users/payjp_id';
  public static STORE_OPTION_REFS = '/studio/store_option_refs';
  public static OPTIONS = '/studio/options';
  public static OPTION_CATEGORIES = '/studio/option_categories';
  public static COUPONS = '/coupons';
}

export class PageName {
  public static TMP_REGISTER = '/tmp_register';
  public static UPDATE = '/update';
  public static LOGIN = '/login';
  public static SUCCESS_TMP_REGISTER = '/success_tmp_register';
  public static SENT_CONFIRMATION_MAIL = '/sent_confirmation_mail';
  public static MYPAGE = '/mypage';
  public static SYSTEM_ERROR = '/system_error';
  public static UPDATE_CONFIRMATION = '/update_confirmation';
  public static STUDIO_SEARCH = '/studio_search';
  public static RESERVATION_LIST = "/reservation_list";
  public static STUDIO_DETAIL = '/studio_detail';
  public static STUDIO_CONFIRM = '/studio_confirm';
  public static STUDIO_COMPLETE = '/studio_complete';
  public static SESSION_TIMEOUT = '/session_timeout';
  public static PASSWORD_RESET_REQUEST = '/password_reset_request';
  public static PASSWORD_RESET_REQUEST_COMPLETE = '/password_reset_request_complete';
  public static PASSWORD_RESET = '/password_reset';
  public static PASSWORD_RESET_COMPLETE = '/password_reset_complete';
}

export class Switch {
  public static DEBUG_SWITCH = process.env.VUE_APP_DEBUG_SW;
}

export class Reg {
  public static nameRegexp = new RegExp('^[ぁ-んァ-ン一-龥a-zA-Z0-9 .\s　!#%\'*+/=^_`{|}~-]{2,20}$');
  public static telRegexp  = new RegExp('^[0-9]{1,11}$');
  public static mailAddressRegexp = new RegExp('^[a-zA-Z0-9.!#$%\'*+/=^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,254}$');
  // public static mailAddressRegexp = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,254}$');
  public static passwordRegexp = new RegExp('^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,20}$');
  public static dateRegexp = new RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}$');
  public static othersRegexp = new RegExp('^[ぁ-んァ-ン一-龥a-zA-Z0-9 \s　a-zA-Z0-9_]{0,50}$');
  public static creditCardNameRegexp = new RegExp('^[A-Z]+(?:[A-Z ]+[A-Z]){1,100}$');
}
